<h1 mat-dialog-title>Select Roadbooks</h1>
<div mat-dialog-content>
    <table class="styled-table">
        <thead>
            <tr>
                <th></th>
                <th>Name</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let ri of roadbooks" class="pointer" (click)="ri.active = !ri.active">
                <td>
                    <mat-checkbox class="example-margin" (click)="$event.stopPropagation()" [checked]="ri.active"></mat-checkbox>
                </td>
                <td>{{ ri.name }}</td>
            </tr>
        </tbody>
    </table>
</div>
<div mat-dialog-actions>
    <button [mat-dialog-close]="getActives()" cdkFocusInitial class="btn btn-success">Select</button>
    <button style="margin-left: 20px" (click)="cancel()" class="btn btn-danger">Cancel</button>
</div>